module.exports = __webpack_public_path__ + "static/award3-da3814f3c1e4f1224b772651a0579e25.png";